import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';
import { NAVIGATE } from 'shared/wizard/actions';
import HypotheekbondLogoSvg from 'images/shared/hypotheekbond-tool.svg';
import CheckedSvg from 'images/shared/checked.svg';
import GeneralToolSvg from "images/shared/general-tool-logo.svg";

function Navigation({ pages, dispatch, logo, settings }) {
  let { state: { page = {} } } = useLocation();
  let currentPageIndex = pages.indexOf(page);
  if (currentPageIndex === -1) currentPageIndex = 0;
  page = pages[currentPageIndex];

  const ToolLogo = logo;

  return [
    settings.enableHypotheekbondLogo ? (
      <div className="hypotheekbond-logo tablet-and-smaller-only">
        <HypotheekbondLogoSvg key="nhb-logo" />
      </div>
    ) : null,

    <nav className="wizard" key="navigation">
      <ol>
        {Object.keys(pages).map((key, i) => {
          const finish = i === pages.length - 1;
          const className = ClassNames({
            finish,
            active: currentPageIndex === i,
            complete: i < currentPageIndex,
          });
          const stepIcon = finish ? (
              <div>
                <ToolLogo />
              </div>
          ) : null;
          return (
            <li
              key={key}
              role="presentation"
              onClick={() => {
                const delta = i - currentPageIndex;
                if (delta < 1) {
                  dispatch({ type: NAVIGATE, delta });
                }
              }}
              className={className}
            >
              {i < currentPageIndex ? (
                <CheckedSvg />
              ) : (
                stepIcon
              )}
            </li>
          );
        })}
      </ol>
      <div className="progress-line" />
      <div
        className="progress-indicator"
        style={{
          width: `${(100 / (pages.length - 1)) * currentPageIndex}%`,
        }}
      />
    </nav>,
  ];
}

const mapStateToProps = state => ({
  syncing: state.syncing,
  pages: state.pages,
  settings: state.settings,
  logo: state.logo,
});

Navigation.propTypes = {
  dispatch: PropTypes.func.isRequired,
  pages: PropTypes.arrayOf(PropTypes.string).isRequired,
  logo: PropTypes.func,
};

Navigation.defaultProps = {
  logo: GeneralToolSvg,
}

export default connect(mapStateToProps)(Navigation);
